import * as React from 'react';
import { observer } from 'mobx-react';
import { motion } from 'framer-motion';

import { useChannelsModalStore } from 'stores/ChannelsModalStore';
import { MobileChannelsModalTab } from 'shared/entities/channels';

import SelectedChannel from '../SelectedChannel';
import CreationContainer from '../CreationContainer';

import ChannelsList from './ChannelsList';

import './ChannelsSection.modules.scss';

type Props = {
  className?: string;
  footer?: React.ReactNode;
};

const ChannelsSection: React.FC<Props> = ({ className, footer }) => {
  const { store } = useChannelsModalStore();
  const channelListFooter = store.scenario || store.bot ? footer : undefined;
  const selectedChannelFooter =
    store.scenario || store.showSelectedChannelScenarios ? footer : undefined;

  const isVisible =
    store.channelsModalSelectedMobileTab.value ===
    MobileChannelsModalTab.createChannel;

  return (
    <div styleName="channels-section" className={className}>
      <motion.div
        animate={isVisible ? 'visible' : 'hidden'}
        transition={{
          stiffness: 0
        }}
        variants={{
          visible: { opacity: 1, x: 0 },
          hidden: { opacity: 0, x: '-100%' }
        }}
        styleName="channels-section__left"
      >
        <CreationContainer />
      </motion.div>
      <motion.div
        animate={!isVisible ? 'visible' : 'hidden'}
        transition={{
          stiffness: 0
        }}
        variants={{
          visible: { opacity: 1, x: '-100%' },
          hidden: { opacity: 0, x: 0 }
        }}
        styleName="channels-section__right"
      >
        <ChannelsList footer={channelListFooter} />
        <SelectedChannel footer={selectedChannelFooter} />
      </motion.div>
    </div>
  );
};

export default observer(ChannelsSection);
